import type { AuditLog } from '../../../models/AuditLog';
import { DataTable } from '../../common/DataTable';
import { formatDateTime } from '../../../utils/date';

export const RecentActivity = ({ items }: { items: AuditLog[] }) => (
  <DataTable
    items={items}
    columns={[
      { columnId: 'entity', label: 'Entity', renderCell: (item) => item.cr_crm_entityname },
      { columnId: 'description', label: 'Description', renderCell: (item) => item.cr_crm_description },
      { columnId: 'user', label: 'User', renderCell: (item) => item.cr_crm_username ?? 'System' },
      { columnId: 'date', label: 'Date', renderCell: (item) => formatDateTime(item.createdon) },
    ]}
    getRowId={(item) => item.cr_crm_auditlogid}
    page={1}
    pageCount={1}
    totalItems={items.length}
    onPageChange={() => undefined}
  />
);
